export default "__VITE_ASSET__CdlVkkg8__"